import { makeStyles } from "tss-react/mui"

import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

/**
 * Pins every column in a `layoutMode="grid"` Material React Table to its configured
 * `size`, and lets only the column tagged with {@link GROW_CELL_CLASS} expand to fill
 * the leftover width.
 *
 * Why this exists: MRT v1 lays grid cells out as flex items with
 * `flex: var(--col-<id>-size) 0 auto`, i.e. flex-grow equals the column size. That makes
 * every column scale proportionally, so small columns (status, actions, expand) inflate
 * just like the name column. Overriding the cell `flex` is the only way to pin a column
 * to an exact width in this MRT version (there is no `grow` column option until v2).
 *
 * Apply the `pinned` class via `muiTablePaperProps`, and add {@link GROW_CELL_CLASS} to
 * the name column's head/body cell props.
 */
export const GROW_CELL_CLASS = "mrt-grow-cell"

export const useGridLayoutStyles = makeStyles()(() => ({
    pinned: {
        "& .MuiTableCell-root": {
            flex: "0 0 auto !important",
        },
        [`& .MuiTableCell-root.${GROW_CELL_CLASS}`]: {
            flex: "1 0 auto !important",
        },
        // The name column sets a per-column head-cell className (to grow), which replaces
        // the table-level head styling MRT applies via Object.assign — re-apply it
        // uniformly to every head cell so the name header stays consistent and aligned.
        "& .MuiTableHead-root .MuiTableCell-root": {
            color: tailwindPalette.slate[500],
            borderBottom: "none",
        },
    },
}))
